<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          :error-messages="GRUPO_ERRORS"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filial"
          label="Filial"
          outlined
          :id-grupo="filtros.grupos"
          :error-messages="FILIAL_ERRORS"
        />
      </div>
    </div>

    <div class="d-flex">
      <div class="w-50-porcento pr-2">
        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          label="Segmentos"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          label="Fornecedores"
          outlined
          multiple
          :ids-segmento="filtros.segmentos"
          :qtde-visivel-selecionados="1"
        />
      </div>
    </div>

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      :qtde-visivel-selecionados="1"
      class="mb-n4"
    />
  </SysDialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import $axios from "@/api/api";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";

export default {
  name: "ProdutosPorFilial",
  mixins: [Mixin],
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete
},
  data: () => ({
    filtros: {
      grupos: 1,
      filial: 1,
      segmentos: [],
      fornecedores: [],
      compradores: [],
    }
  }),
  computed: {
    GRUPO_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.grupos.$dirty) return errors;
      !this.$v.filtros.grupos.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.filial.$dirty) return errors;
      !this.$v.filtros.filial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  },
  validations: {
    filtros: {
      grupos: { required },
      filial: { required },
    }
  }
}
</script>

<style scoped>

</style>
